<template>
  <b-form @submit.prevent="submit">
    <b-row>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('NAME')">
          <b-form-input  type="text" :value="user.name" :disabled="true"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="6" lg="4">
        <b-form-group :label="$t('EMAIL')">
          <b-form-input  type="email" :value="user.email" :disabled="true"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" lg="4">
        <b-form-group :label="$t('LANGUAGE')">
          <b-form-select v-model="preferred_language" id="basicLanguage"
                         value-field="code" text-field="name"
                         :options="languages"
          >
          </b-form-select>
          <validation-description :show="$v.preferred_language.$dirty && $v.preferred_language.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <app-button-submit :loading="loading" ></app-button-submit>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
  import {toast} from '@/shared/plugins/toastr'
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import DatePicker from '@/components/app/datetime/DatePicker'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {required} from "vuelidate/lib/validators";
  import {cloneDeep} from "lodash";
    export default {
      name: "user-basic-form",
      mixins: [getErrorMessage],
      data() {
        return{
          email: null,
          name: null,
          preferred_language: null,
          disabled: true,
          loading:false,
          languages: [
            { code: 'bs', name: this.$t('BA') },
            { code: 'hr', name: this.$t('HR')  },
            { code: 'sr', name: this.$t('SR')  },
          ],
        }
      },
      validations:{
        preferred_language: {required},
      },
      components: {
        AppButtonSubmit, DatePicker, ValidationDescription
      },
      computed: {
        user() {
          return this.$store.getters['user/getUser']
        },
      },
      methods:{
        submit() {
          this.$v.$touch()
          if(this.$v.$invalid){
            toast({
              'title': this.$t('VALIDATION_FAILED'),
              'message': null,
              'type': 'error',
              'timeout': 6000
            })
            return
          }

          let data = {
            preferred_language: this.preferred_language,
          }
          this.$store.dispatch('user/actionUpdateUser', {id: this.user.id, data }).then(() => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                type: 'success',
                timeout: 3000
              })
            },
            error => {
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                type: 'error',
                timeout: 6000
              })
            })
        }
      },
      mounted() {
        this.preferred_language = cloneDeep(this.user.preferred_language);
      }
    }
</script>

<style scoped>

</style>
